<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <div v-if="errors.any() || error" id="feedback">
          <p v-if="errors.has('oldpassword')" class="error wrong_message error-box">
            Please enter your current password
          </p>
          <p v-if="errors.has('New Password')" class="error wrong_message error-box">
            {{ errors.first('New Password') }}
          </p>
          <p v-if="errors.has('repeatpassword')" class="error wrong_message error-box">
            Please repeat password
          </p>
          <p v-if="error" class="error wrong_message error-box">
            {{ error }}
          </p>
        </div>
        <form v-if="user" name="formcpw">
          <p>
            Current Password:
            <input v-model="oldPassword" v-validate="'required'" type="password" name="oldpassword">
          </p>
          <p>New Password: <input v-model="newPassword" v-validate="'min:8|required|confirmed:repeatpassword'" type="password" name="New Password" data-vv-delay="2000"></p>
          <p>Confirm Password: <input v-model="confirmPassword" v-validate="'required'" type="password" name="repeatpassword" data-vv-delay="2000"></p>
          <p><input type="submit" name="submit" class="big-btn blue" value="Update Password" @click.prevent="save"></p>
        </form>
      </div>
      <!-- main-colum END here -->
    </div>
    <!-- container END here -->
  </div>
  <!-- content END here -->
</template>

<script>
import AuthRepository from '../data/auth.repository'
export default {
  data () {
    return {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      error: ''
    }
  },
  computed: {
    user () {
      return this.$store.state.currentUser
    }
  },
  methods: {
    save () {
      this.$validator.validateAll().then(() => {
        const obj = {oldPassword: this.oldPassword, newPassword: this.newPassword, confirmPassword: this.confirmPassword, id: this.user.id}
        AuthRepository.changePassword(obj).then((result) => {
          this.$root.$refs.toastr.s('Password updated')
          this.$router.push('/myaccount')
        }).catch(e => {
          if (e.response && e.response.data && e.response.data.error) {
            this.error = e.response.data.error
          }
        })
      })
    }
  },
  metaInfo: {
    title: 'Change Password'
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// ChangePassword.vue?1acc247b